const ITEMS = [
    "Revisoría Fiscal",
    "Planeación Tributaria",
    "NIIF para PYMES",
    "Outsourcing Contable",
    "Facturación Electrónica",
    "Nómina y PILA",
    "Cámara de Comercio",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            className="overflow-hidden border-y border-gold/20 bg-navy-deep py-6"
            data-testid="editorial-marquee"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="whitespace-nowrap font-display text-2xl italic text-[#F8F9FA]/75 md:text-3xl">
                            {item}
                        </span>
                        <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-gold/70" />
                    </span>
                ))}
            </div>
        </div>
    );
}
